/* istanbul ignore file */
// no business logic, will cover it with TODO: cypress
import { CLASSNAME_HIDDEN } from '@vfde-brix/core';
import { CONTAINER_FORM,
    CONTAINER_NOTIFICATION_SERVICE_NOT_AVAILABLE,
    CONTAINER_REGISTRATION_SUCCEED,
    CONTAINER_REGISTRATION_TRY_AGAIN} from 'Constant';

/**
 * Export showSuccessNotification
 *
 * @export showSuccessNotification
 */
 export const showSuccessNotification = () => {
    const containerForm = document.getElementById(CONTAINER_FORM) as HTMLElement;
    const containerRegistrationSucceed = document.getElementById(CONTAINER_REGISTRATION_SUCCEED) as HTMLElement;

    containerForm.classList.add(CLASSNAME_HIDDEN);
    containerRegistrationSucceed.classList.remove(CLASSNAME_HIDDEN);
    // scroll to notification
    window.scrollTo({top: 500, behavior: 'smooth'});
};

/**
 * Export showSuccessNotification
 *
 * @export showSuccessNotification
 */
 export const showTryAgainNotification = () => {
    const containerForm = document.getElementById(CONTAINER_FORM) as HTMLElement;
    const containerRegistrationFailed = document.getElementById(CONTAINER_REGISTRATION_TRY_AGAIN) as HTMLElement;

    containerForm.classList.toggle(CLASSNAME_HIDDEN, true);
    containerRegistrationFailed.classList.remove(CLASSNAME_HIDDEN);
    // scroll to notification
    window.scrollTo({top: 500, behavior: 'smooth'});
};

/**
 * Export showServiceNotAvailableNotification
 *
 * @export showServiceNotAvailableNotification
 */
 export const showServiceNotAvailableNotification = () => {
    const containerServiceNotAvailable = document.getElementById(CONTAINER_NOTIFICATION_SERVICE_NOT_AVAILABLE) as HTMLElement;

    containerServiceNotAvailable.classList.remove(CLASSNAME_HIDDEN);
};
